<section class="flex flex-col gap-4 p-6">
  <p class="text-paragraph-med text-primary-900">
    {{ "prestation.mealType" | transloco }}
  </p>
  <app-category-selector
    [categoryList]="typeList"
    [(selectedValue)]="type"
    type="list"
    orientation="col"
  />
</section>
